<!-- da fare test -->

<!--
  No *ngIf on imageUrl: resolveImageUrl always answers a loadable string (the bundled default
  for a row the backend has no picture for), so gating here is what used to leave an empty cell.

  alt names the PRODUCT, never the stored path. Bound to imageUrl it was harmless while the
  *ngIf hid the tile; unconditional, it makes a screen reader announce the placeholder's file
  path once per picture-less row. altText is '' when no name resolves -- decorative, skipped.
-->
<!--
  The thumbnail opens the enlarged preview, so it is a CONTROL and is a real <button>: a bare
  <img (click)> had no tab stop, no Enter/Space and no role (WCAG 2.1.1 / 4.1.2), and
  `npm run audit:pointeronly` refuses that shape now. The button is named for what it does; the
  product it shows comes from altText, and the generic name stands in when nothing names it (a
  bound alt that resolves to '' would leave the button nameless). The <img> inside is therefore
  decorative: alt="" so the name is not read twice.

  Never set rowLink on a list carrying this column: the cell would wrap this button in the row
  anchor, which is invalid HTML (see "Table row navigation" in CLAUDE.md).
-->
<!--
  The label serves as both the name and the tooltip: a sighted user cannot tell from the picture
  that pressing it enlarges it, and the tooltip being the same string as the aria-label is what
  stops CDK describing the control with its own name a second time (AriaDescriber._canBeDescribed).
  Written out twice rather than held in an *ngIf variable: this template carries no *ngIf by rule
  (see above), and altText is a field, so the repeat costs one cheap pipe. (detach) resyncs isOpen
  however the overlay closed: CDK detaches on Escape by itself and does not touch the
  [cdkConnectedOverlayOpen] input.
-->
<button type="button" class="g15-img-control" #trigger="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="isOpen = !isOpen; $event.stopPropagation()" [attr.aria-expanded]="isOpen"
        [attr.aria-label]="altText ? ('common.actions.enlargeImageNamed' | translate: { name: altText }) : ('common.actions.enlargeImage' | translate)"
        [matTooltip]="altText ? ('common.actions.enlargeImageNamed' | translate: { name: altText }) : ('common.actions.enlargeImage' | translate)">
  <img [src]="imageUrl" alt="" width="24" height="30" (error)="noImage()">
</button>
  
  <ng-template #cdkConOverlay="cdkConnectedOverlay" cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger"
               [cdkConnectedOverlayOpen]="isOpen" (detach)="isOpen = false">
  
    <div class="d-flex panel_onfire justify-content-center flex-column align-items-center w-100">
  
      <div class="d-flex w-100" style="max-width: 200px;">
  
        <img [src]="imageUrl" [alt]="altText" width="200" height="300">
  
      </div>
  
    </div>
  </ng-template>
